module.exports = __webpack_public_path__ + "img/jump_lg.03d19584.png";